import {useIntl} from 'react-intl';
import * as React from 'react';
import {useEffect, useState, useRef} from 'react';
import {DynamicForm} from "@xal3xfx/react-utils";
import {formElements} from "./user-form";
import {
    Api, RegisterUserRequest, UpdateUserRequest, UserDTO,
} from "../../../../lib/services/mainApi";
import {createValidationSchema, updateValidationSchema} from "./validation";
import {useToast} from "../../../../lib/hooks/useToast";
import {Button} from "primereact/button";

interface Props {
    createdCb: () => void;
    selectedUser?: UserDTO;
}

const initialValues: RegisterUserRequest = {
    username: "",
    password: "",
}

const CreateOrUpdateUser: React.FC<Props> = props => {
    const api = new Api();
    const didMountRef = useRef(false);
    const {formatMessage: f} = useIntl();
    const {showToast} = useToast();

    const [generatedPassword, setGeneratedPassword] = useState<string>();
    const [initialValuesState, setInitialValuesState] = useState<RegisterUserRequest | UpdateUserRequest>({...initialValues});
    const [formElementsState, setFormElementsState] = useState({...formElements});

    useEffect(() => {
        if (!didMountRef.current) {
            didMountRef.current = true;
        }
    }, []);

    useEffect(() => {
        if(!props.selectedUser) return;
        setInitialValuesState({
            userId: props.selectedUser.id,
            username: props.selectedUser.username,
            locationTag: props.selectedUser.locationTag,
            enableExtraOptions: props.selectedUser.enableExtraOptions,
        })
    }, [props.selectedUser])

    const handleCreate = (data: RegisterUserRequest | UpdateUserRequest) => {
        return new Promise<boolean>((resolve, reject) => {
            api.api.adminV1UserCreate(data as RegisterUserRequest)
                .then(resp => {
                    if (resp.data) {
                        props.createdCb();

                        showToast('success', '', f({id: 'userCreatedSuccessfully'}));
                        resolve(true);
                    }
                })
                .catch(err => {
                    if(err.response.status === 400 && err.response.data.errorMessage && err.response.data.errorMessage === "Validation failed" && err.response.data.detailedErrors) {
                        let errorsList = <ul>
                            {err.response.data.detailedErrors.map((value: {errorCode:string, errorMessage: string}) => {
                                return <li>{value.errorMessage}</li>
                            })}
                        </ul>
                        showToast("warn", f({id: "operationUnsuccessful"}), errorsList, true);
                        return Promise.reject(err)
                    }
                })
        })
    }

    const handleUpdate = (data: UpdateUserRequest) => {
        return new Promise<boolean>((resolve, reject) => {
            api.api.adminV1UserUpdate(data)
                .then(resp => {
                    if (resp.data) {
                        if (props.createdCb) props.createdCb();
                        showToast('success', '', f({id: 'userUpdatedSuccessfully'}));
                        resolve(true);
                    }
                })
                .catch()
        })
    }

    const handleCopyToClipboard = () => {
        navigator.clipboard.writeText(generatedPassword || "");
        showToast('success', '', f({id: 'passwordCopied'}));
        if(props.createdCb) props.createdCb();
    }

    return <>
        {generatedPassword ?
            <div className={"flex justify-content-center align-items-center text-lg"}>
                <>{f({id: "generatedPasswordIs"}, {generatedPassword: <b>{generatedPassword}</b>})}</>
                <Button text={true} className={"ml-3"} icon={"pi pi-clone"} onClick={handleCopyToClipboard}/>

            </div>
            :
            <DynamicForm formElements={formElementsState} isUpdate={props.selectedUser !== undefined} onCreate={handleCreate}
                         onUpdate={handleUpdate} validationSchema={props.selectedUser ? updateValidationSchema : createValidationSchema}
                         initialValues={initialValuesState} formButtonsClassName={"col-12 md:col-4"} rowClassName={"col-12 md:col-4 mt-3"}
                         fieldOrder={['username', 'password', 'locationTag', "enableExtraOptions"]}
                         onCancelUpdate={props.createdCb}/>
        }
    </>
};

export default CreateOrUpdateUser
